import BackButtonToolbar from "features/BackButtonToolbar";
import {
  Show,
  SimpleShowLayout,
  DateField,
  TextField,
  Labeled,
  TopToolbar,
  ReferenceField,
  useShowController,
} from "react-admin";
import { Box, Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { getAvailability } from "../helpers";
import ApproveEmployer from "components/CareerCenter/Employers/ApproveEmployer";
import RejectEmployer from "components/CareerCenter/Employers/RejectEmployer";
import ReturnEmployerForCorrection from "components/CareerCenter/Employers/ReturnEmployerForCorrection";
import { careerCenterRequests } from "api/careerCenterApi";
import { SectionTitle } from "features/SectionTitle";

const ShowEmployers = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const { record } = useShowController();

  const { isAvailableForCorrection, isAvailableForApprove, isAvailableForReject } = getAvailability(record?.status);

  return (
    <Show
      title="Детайли на работодател"
      actions={
        <TopToolbar sx={{ paddingTop: "2rem", paddingRight: "2rem", gap: "1rem" }}>
          {isAvailableForApprove && (
            <SecuredComponent permission={permissions.canManageEmployers}>
              <ApproveEmployer />
            </SecuredComponent>
          )}
          {isAvailableForReject && (
            <SecuredComponent permission={permissions.canManageEmployers}>
              <Box
                display="flex"
                justifyContent="flex-end"
                alignItems={"center"}
                pb={1}
              >
                <RejectEmployer />
              </Box>
            </SecuredComponent>
          )}
          {isAvailableForCorrection ? (
            <SecuredComponent permission={permissions.canManageEmployers}>
              <ReturnEmployerForCorrection />
            </SecuredComponent>
          ) : null}

          <BackButtonToolbar />
        </TopToolbar>
      }
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          fontSize={14}
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Име на фирмата">
              <TextField
                source="companyName"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Булстат">
              <TextField
                source="bulstat"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="МОЛ">
              <TextField
                source="mol"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Адрес на управление">
              <TextField
                source="managementAddress"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Лице за контакт">
              <TextField
                source="contactPerson"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Телефон за контакт">
              <TextField
                source="contactPhone"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
          >
            <Labeled label="Имейл за контакт">
              <TextField
                source="contactEmail"
                emptyText="-"
              />
            </Labeled>
          </Grid>
        </Grid>
        <SectionTitle
          title="Допълнителна Информация"
          textAlign="center"
          fontSize={14}
          sx={{ marginTop: "2rem" }}
        />
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
          >
            <Labeled label="Описание">
              <TextField
                source="organizationDescription"
                emptyText="-"
              />
            </Labeled>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Създадена на">
              <DateField
                locales="bg-BG"
                showTime
                source="createdOn"
                emptyText="-"
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
          >
            <Labeled label="Статус">
              <ReferenceField
                label="Статус"
                source="status"
                reference={careerCenterRequests.getStatusesSelect()}
              >
                <TextField source="nameBg" />
              </ReferenceField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};
export default ShowEmployers;
